import {IApplicationReducerData} from "../../types/IApplicationReducerData";

export const getRodoDataFromApplication = (application?: IApplicationReducerData) => {
    if (!application) {
        return {vendorName: undefined, offerPersonalDataProcessorName: undefined, rodoLinks: undefined};
    }

    return {
        vendorName: application?.vendor?.detail?.name,
        offerPersonalDataProcessorName: application?.offer?.detail?.configuration.personal_data_processor_name,
        rodoLinks: {
            offerPersonalDataProcessorUrl: application?.offer?.detail?.configuration.personal_data_processor_url,
            offerPrivacyPolicyUrl: application?.offer?.detail?.configuration.privacy_policy_url,
            vendorPrivacyPolicyFile: application?.vendor?.detail?.configuration.privacy_policy_file,
            vendorPrivacyPolicyUrl: application?.vendor?.detail?.configuration.privacy_policy_url
        }
    };
};
